const imagesCarousel = {
  backgroundColor: ({ theme }) => theme.colors.green,
}

export default imagesCarousel
